import { decamelizeKeys } from 'humps';

import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';

export function convertToFormData<T extends Record<string, any>>(
  body: T,
  customKey?: Partial<
    Record<keyof T, (key: string, value: any, formData: FormData) => void>
  >,
  formData = new FormData(),
): FormData {
  Object.entries(body).forEach(([key, value]) => {
    if (customKey?.[key as keyof T]) {
      customKey[key as keyof T]!(key, value, formData);
    } else if (Array.isArray(value)) {
      value.forEach(item => {
        formData.append(key, item);
      });
    } else {
      formData.set(key, value instanceof File ? value : String(value || ''));
    }
  });

  return formData;
}

export function createJsonBlob<T extends Record<string, any>>(data: T): Blob {
  return new Blob([JSON.stringify(decamelizeKeys(data))], {
    type: headers.accept,
  });
}

export const bannerImgConverter = (
  key: string,
  value: File | string | null,
  formData: FormData,
) => {
  if (value instanceof File) {
    formData.set(key, value);
  } else if (value === null || value === '') {
    formData.set(key, '');
  }
};

export const jsonFieldConverter = (
  key: string,
  value: unknown,
  formData: FormData,
) => {
  if (value === undefined || value === null) return;
  formData.set(key, JSON.stringify(value));
};

export const feedbacksConverter = (
  key: string,
  feedbacks: Array<Record<string, unknown>> | undefined,
  formData: FormData,
) => {
  if (!Array.isArray(feedbacks)) return;
  feedbacks.forEach((feedback, index) => {
    Object.entries(feedback).forEach(([field, value]) => {
      if (value === undefined || value === null) return;
      const formKey = `${key}[${index}]${field}`;
      if (typeof value === 'object') {
        formData.append(formKey, JSON.stringify(value));
      } else {
        formData.append(formKey, String(value));
      }
    });
  });
};
